export default __webpack_public_path__ + "static/media/frotas-corporativo.9642c92b.svg";